import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderPagesStore implements SaveStateHolder {
  @observable
  readonly pageIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly  lessonId: number,
              pageIds: number[]) {
    makeObservable(this);
    this.pageIds = pageIds.slice();
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.pageIds, index1, index2);
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    const reordered = this.pageIds.slice();
    this.save = contentLoaders.x5lesson.orderChildren(this.lessonId, reordered);
  };
}
